import moment from "moment";

declare module "moment" {
  // see https://github.com/lennym/moment-business-time
  export interface Moment {
    isWorkingDay(): boolean;
    isWorkingTime(): boolean;
    nextWorkingDay(): moment.Moment;
    nextWorkingTime(): moment.Moment;
    lastWorkingDay(): moment.Moment;
    lastWorkingTime(): moment.Moment;

    addWorkingTime(
      amount: moment.DurationInputArg1,
      unit: moment.DurationInputArg2
    ): moment.Moment;

    subtractWorkingTime(
      amount: moment.DurationInputArg1,
      unit: moment.DurationInputArg2
    ): moment.Moment;

    workingDiff(
      b: moment.MomentInput,
      unitOfTime: moment.unitOfTime.Diff,
      precise?: boolean
    ): number;
  }
}

export default moment;
